"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.S3API = void 0;
class S3API {
    constructor(baseUrl) {
        this.baseUrl = baseUrl;
    }
    setToken(token) {
        this.token = token;
    }
    getHeaders(contentType = 'application/json') {
        const headers = {
            'Content-Type': contentType,
        };
        if (this.token) {
            headers['Authorization'] = `Bearer ${this.token}`;
        }
        return headers;
    }
    /**
     * S3에서 파일을 다운로드하거나 조회합니다.
     */
    getFile(key_1) {
        return __awaiter(this, arguments, void 0, function* (key, download = false) {
            const params = new URLSearchParams(Object.assign({ key }, (download && { download: 'true' })));
            const response = yield fetch(`${this.baseUrl}/api/s3?${params}`, {
                headers: this.getHeaders(),
            });
            if (!response.ok) {
                throw new Error('파일 다운로드에 실패했습니다');
            }
            return response;
        });
    }
}
exports.S3API = S3API;
